<script lang="ts" setup>
import { computed } from 'vue';

import PatientAvatar from '@/components/PatientAvatar.vue';
import type { ChatPatientAnswer } from '@sigma/chat-common/ChatEvent.js';
import { defineChatEventProps } from '@sigma/client/chat/defineChatEventProps.js';
import ChatEventWrapper from '@sigma/ui/chat/ChatEventWrapper.vue';
import ChatMessage from '@sigma/ui/chat/ChatMessage.vue';
import ChatAnswer from '@sigma/ui/chat/forms/ChatAnswer.vue';

import chatCss from './chat.module.scss';

const props = defineProps(defineChatEventProps<ChatPatientAnswer>());

const questionEvent = computed(() => {
  for (const event of props.chat.events) {
    if (event.type === 'AGENT_QUESTION' && event.seq === props.event.questionSeq) {
      return event;
    }
  }
  return null;
});
</script>

<template>
  <ChatEventWrapper
    tid="patient-answer"
    :event="event"
    :class="chatCss.container"
  >
    <ChatMessage
      v-if="questionEvent"
      color="blue"
      align="right"
      :timestamp="event.timestamp"
    >
      <template #avatar>
        <PatientAvatar />
      </template>

      <template #content>
        <ChatAnswer
          :config="questionEvent.input"
          :value="event.answer"
        />
      </template>
    </ChatMessage>
  </ChatEventWrapper>
</template>
